

export class MotivosEntity
{
    public  CodigoMotivo ?: number;
    public  Descripcion?: string;
    public Estado?:number;
    public  lstCriterios?: CriteriosEntity[];

    
}
export class CriteriosEntity
{
    public  CodigoCriterio ?: number;
    public  Descripcion?: string;
    public Estado?:number;
    public Nuevo?:boolean;
    public Eliminar?:boolean;
    public  CodigoMotivo ?: number;
    
}
export class AceptacionCarteraEntity
{
    public Codigo  ?: number;
    public CodigoMotivo?: number;
    public Pais?:string;
    public Factura?:string;
    public Decision?:string;
    public Tipo?:string;
    public FechaSolicitud?:Date;
    public FechaDecision?:Date;
    public FechaVencimiento?:Date;
    public MontoSolicitado?:number;
    public MontoOtorgado?:number;
    public Comentarios?:string;
    public FechaCreacion?:Date;
    public Estado?:number;
    public InformacionComprador?:CompradorEntity;
    public Codificacion?:string;
    public Motivos?:string;
    
}
export class SeguroCreditoEntity
{
    //public DatosCliente?: DatosCliente;
    public AceptacionCartera?: AceptacionCarteraEntity[];
    public Siniestralidad?: SiniestralidadEntity[];
    public TipoImportacion?:number;
    public Mes?:number;
    public UsoCupos?: UsuCupoEntity[];
    public MontoSolictado?:number;
    public ValorPrimas?:number;
    public Reclamos?:number;

}
export class UsuCupoEntity
{
    public Codigo  ?: number;
    public DiasPedido?: number;
    public FechaPedido?:Date;
    public MontoSolicitado?:number;
    public MontoAprobado?:number;
    public Perdiodos?:number;
    public Actividad?:number;
    public FechaCreacion?:Date;
    public Estado?:number;
    public InformacionComprador?:CompradorEntity;
    public SinActividad?:number;
    public EstresLiminte?:number;
    public Sugerencia?:string;
    public Accion?:string;  
    public Nomindados?:number;
    public Discrecional?:number;
    public Mes?:string;
    
}
export class SiniestralidadEntity
{
    public Codigo  ?: number;
    public AnioVigencia?: number;
    public Ciudad?:string;
    public Oficina?:string;
    public FechaAmenaza?:Date;
    public TotalDeudaPresentada?:number;
    public MesUyv?:Date;
    public Discrecional?:boolean;
    public LineaCredito?:number;
    public ValorFueraCob?:number;
    public CoberturaParcial?:string;
    public ReservaInicial?:number;
    public SaldoFinalCob?:number;
    public FechaCreacion?:Date;
    public Estado?:number;
    public InformacionComprador?:CompradorEntity;
    public PorcentajeCobertura?:number;
    public ValorIndemnizar?:number;
    public Codificacion?:string;
    public FechaPago?:Date;
    public NombreDiscrecional?:string;
    public DirectamenteAse?:number;
    public SaldoFinalInd?:number;
    public StatusCobertura?:string;
    public RazonNoCoberura?:string;
    public FechaInicio?:Date;
    public FechaFin?:Date;
}
export class CompradorEntity
{
    public Codigo?:number;
    public CodigoCliente?:number;
    public CodigoClienteAlterno?:number;
    public CedulaRuc?:string;
    public RazonSocial?:string;
    public CodigoCiudad?:number;
}

export class GestionesCreditoEntity
{
    public Codigo?:number;
    public FechaCreacion?:number;
    public Gestion?:number;
    public FechaPorximaGestion?:string;
    public CodigoComprador?:number;
    public CodigoCiudad?:number;
    public Nuevo?:boolean;
    public Editar?:boolean;
    public Tipo?:number;
    
}


export class CriteriosBusqueda
{
    public  FechaDesde ?: Date;
    public  FechaHasta?: Date;
   
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/sistema_credito_entity.ts